/**
 * Browser-safe plugin layout preview (no API, no Node fs).
 */

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function sceneDimensions(orientation) {
  return orientation === 'portrait'
    ? { width: 1080, height: 1920 }
    : { width: 1920, height: 1080 };
}

const PREVIEW_SHELL_CSS = (orientation) => {
  const { width, height } = sceneDimensions(orientation);
  return `
html.preview, html.preview body { width: 100%; height: 100%; margin: 0; overflow: hidden; }
html.preview body { position: relative; background: #000; }
html.preview .scene {
  position: absolute; left: 50%; top: 50%;
  width: ${width}px; height: ${height}px;
  transform-origin: center center;
}
html.preview .anim-fade, html.preview .anim-slide {
  opacity: 1 !important; transform: none !important;
}
html.preview .skeleton-logo {
  display: inline-block; background: rgba(255,255,255,0.18); border-radius: 50%;
}
html.preview .solo-logo.skeleton-logo { width: 120px; height: 120px; }
html.preview .team-logo.skeleton-logo { width: 40px; height: 40px; }
`;
};

const PREVIEW_BOOT_SCRIPT = `
<script>
(function() {
  function sceneSize() {
    var p = document.documentElement.classList.contains('portrait');
    return p ? { w: 1080, h: 1920 } : { w: 1920, h: 1080 };
  }
  function fitPreview() {
    var scene = document.querySelector('.scene');
    if (!scene) return;
    var sz = sceneSize();
    var scale = Math.min(window.innerWidth / sz.w, window.innerHeight / sz.h);
    if (!Number.isFinite(scale) || scale <= 0) scale = 0.1;
    scene.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
  }
  if (typeof window.__pluginTick === 'function') window.__pluginTick(2);
  fitPreview();
  window.addEventListener('resize', fitPreview);
  requestAnimationFrame(fitPreview);
})();
</script>`;

const WEATHER_CSS = `* { box-sizing: border-box; margin: 0; padding: 0; }
html, body { width: 100%; height: 100%; overflow: hidden; font-family: -apple-system, BlinkMacSystemFont, sans-serif; color: #fff; }
html.landscape .scene { width: 1920px; height: 1080px; }
html.portrait .scene { width: 1080px; height: 1920px; }
.scene { position: relative; display: flex; flex-direction: column; justify-content: space-between; padding: 48px 56px 40px; }
.hero { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; opacity: 0; }
.location { font-size: 42px; font-weight: 500; margin-bottom: 8px; }
.temp { font-size: 180px; font-weight: 200; line-height: 1; }
html.portrait .temp { font-size: 140px; }
.condition { font-size: 36px; margin-top: 4px; }
.hi-lo { font-size: 28px; margin-top: 12px; opacity: 0.85; }
.glass-card { background: rgba(20,40,80,0.45); border-radius: 28px; padding: 28px 32px 20px; border: 1px solid rgba(255,255,255,0.12); opacity: 0; }
.summary { font-size: 22px; line-height: 1.45; margin-bottom: 20px; }
.hourly-row { display: flex; gap: 8px; overflow: hidden; }
.hour-col { min-width: 72px; display: flex; flex-direction: column; align-items: center; gap: 10px; }
.hour-label { font-size: 16px; }
.wx-icon { width: 36px; height: 36px; }
.hour-temp { font-size: 22px; }
.attribution { font-size: 13px; opacity: 0.5; margin-top: 14px; text-align: right; }`;

const SPORTS_CSS = `* { box-sizing: border-box; margin: 0; padding: 0; }
html, body { width: 100%; height: 100%; overflow: hidden; font-family: -apple-system, BlinkMacSystemFont, sans-serif; color: #fff;
  background: linear-gradient(145deg, #0f172a 0%, #1e293b 40%, #334155 100%); }
html.landscape .scene { width: 1920px; height: 1080px; }
html.portrait .scene { width: 1080px; height: 1920px; }
.scene { display: flex; flex-direction: column; padding: 40px 48px; height: 100%; }
.scene-solo { padding-top: 28px; }
.header { margin-bottom: 28px; opacity: 0; }
.header-compact { margin-bottom: 12px; text-align: center; }
.header-compact .title { font-size: 36px; }
.title { font-size: 48px; font-weight: 600; }
.subtitle { font-size: 24px; opacity: 0.7; margin-top: 6px; }
.scoreboard { flex: 1; display: grid; gap: 20px; opacity: 0; min-height: 0; }
.solo-grid { grid-template-columns: 1fr; }
.duo-grid { grid-template-columns: repeat(2, 1fr); }
.quad-grid { grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(2, 1fr); }
.six-grid { grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(2, 1fr); }
.many-grid { grid-template-columns: repeat(3, 1fr); }
.game-card { background: rgba(255,255,255,0.08); border-radius: 20px; border: 1px solid rgba(255,255,255,0.1);
  padding: 20px 24px; padding-top: 48px; position: relative; display: flex; flex-direction: column; justify-content: center; }
.game-card.solo { flex: 1; padding: 32px 48px 40px; align-items: center; }
.solo-center { display: flex; align-items: center; justify-content: center; gap: 48px; width: 100%; }
.solo-side { display: flex; flex-direction: column; align-items: center; gap: 20px; flex: 1; }
.solo-abbr { font-size: 48px; font-weight: 700; }
.solo-scores { display: flex; align-items: center; gap: 28px; }
.solo-score { font-size: 160px; font-weight: 200; line-height: 1; }
.solo-divider { font-size: 72px; opacity: 0.45; }
.solo-clock { margin-top: 24px; font-size: 22px; color: #fca5a5; text-align: center; }
.solo-league { margin-top: 20px; text-align: center; font-size: 16px; opacity: 0.65; }
.status-badge { position: absolute; top: 16px; right: 18px; display: flex; align-items: center; gap: 8px; }
.status-text { font-size: 13px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; }
.status-live .status-text { color: #fca5a5; }
.live-dot { width: 12px; height: 12px; border-radius: 50%; background: #ef4444; }
.status-final .status-text { color: #94a3b8; }
.status-upcoming .status-text { color: #cbd5e1; font-size: 11px; }
.game-clock { font-size: 13px; font-weight: 600; color: #fca5a5; margin-bottom: 10px; }
.teams { display: flex; flex-direction: column; gap: 12px; }
.team-row { display: flex; align-items: center; gap: 14px; }
.team-abbr { font-size: 28px; font-weight: 600; flex: 1; }
.team-score { font-size: 36px; font-weight: 700; }
.league-tag { position: absolute; bottom: 14px; left: 18px; font-size: 12px; opacity: 0.55; }
.game-card.quad, .game-card.six, .game-card.many { display: flex; flex-direction: column; justify-content: flex-start; height: 100%; padding-bottom: 14px; }
.game-card.quad .card-body, .game-card.six .card-body, .game-card.many .card-body { flex: 1 1 0; display: flex; flex-direction: column; justify-content: center; min-height: 0; }
.game-card.quad .league-tag, .game-card.six .league-tag, .game-card.many .league-tag {
  position: static; flex: 0 0 auto; margin-top: 12px; padding-top: 14px; line-height: 1.25; }
.game-card.six .teams, .game-card.many .teams { gap: 8px; }
.game-card.duo .team-abbr { font-size: 36px; }
.game-card.duo .team-score { font-size: 52px; }
.game-card.quad .team-abbr { font-size: 30px; }
.game-card.quad .team-score { font-size: 42px; }
.game-card.six .team-abbr { font-size: 24px; }
.game-card.six .team-score { font-size: 32px; }
.game-card.many .team-abbr { font-size: 20px; }
.game-card.many .team-score { font-size: 26px; }`;

function wrapPreviewHtml(bodyHtml, orientation, pluginCss, bodyStyle) {
  const orient = orientation === 'portrait' ? 'portrait' : 'landscape';
  return `<!DOCTYPE html>
<html lang="en" class="${orient} preview">
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1"/>
<style>${pluginCss}${PREVIEW_SHELL_CSS(orient)}</style>
</head>
<body${bodyStyle ? ` style="${bodyStyle}"` : ''}>
${bodyHtml}
<script>
window.__pluginTick = function(t) {
  document.querySelectorAll('.anim-fade').forEach(function(el) { el.style.opacity = Math.min(1, t / 0.8); });
  document.querySelectorAll('.anim-slide').forEach(function(el) {
    el.style.transform = 'translateY(' + Math.max(0, 24 - t * 30) + 'px)';
    el.style.opacity = Math.min(1, t / 1.0);
  });
};
</script>
${PREVIEW_BOOT_SCRIPT}
</body>
</html>`;
}

function weatherIconSvg(code, isDay) {
  if (code <= 1) {
    return isDay
      ? '<svg viewBox="0 0 24 24" class="wx-icon"><circle cx="12" cy="12" r="5" fill="#FFD60A"/></svg>'
      : '<svg viewBox="0 0 24 24" class="wx-icon"><circle cx="12" cy="12" r="5" fill="#E8E8FF"/></svg>';
  }
  return '<svg viewBox="0 0 24 24" class="wx-icon"><ellipse cx="12" cy="14" rx="8" ry="5" fill="rgba(255,255,255,0.9)"/></svg>';
}

function buildWeatherPreviewData(config = {}) {
  const locationName = config.locationName || 'Your City';
  const units = config.units === 'celsius' ? 'celsius' : 'fahrenheit';
  const hourlyLabels = ['Now', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM'];
  return {
    locationName,
    temperature: units === 'celsius' ? 22 : 72,
    high: units === 'celsius' ? 24 : 78,
    low: units === 'celsius' ? 18 : 65,
    condition: 'Partly Cloudy',
    summary: 'Morning clouds, then clearing this afternoon.',
    weatherCode: 2,
    isDay: true,
    hourly: hourlyLabels.map((label, i) => ({
      label,
      temp: units === 'celsius' ? 20 + i : 68 + i,
      weatherCode: i % 3 === 0 ? 0 : 2,
      isDay: true,
    })),
  };
}

function buildWeatherPreviewHtml(config = {}, options = {}) {
  const orientation = options.orientation === 'portrait' ? 'portrait' : 'landscape';
  const data = buildWeatherPreviewData(config);
  const bg = 'linear-gradient(180deg, #6a9fd4 0%, #8eb8e0 40%, #b0cfe8 100%)';
  const hourlyHtml = data.hourly.map((h) => `
    <div class="hour-col">
      <span class="hour-label">${escapeHtml(h.label)}</span>
      ${weatherIconSvg(h.weatherCode, h.isDay)}
      <span class="hour-temp">${h.temp}°</span>
    </div>`).join('');

  const body = `
  <div class="scene">
    <div class="hero anim-fade">
      <div class="location">${escapeHtml(data.locationName)}</div>
      <div class="temp">${data.temperature}°</div>
      <div class="condition">${escapeHtml(data.condition)}</div>
      <div class="hi-lo">H:${data.high}°  L:${data.low}°</div>
    </div>
    <div class="glass-card anim-slide">
      <p class="summary">${escapeHtml(data.summary)}</p>
      <div class="hourly-row">${hourlyHtml}</div>
      <p class="attribution">Layout preview</p>
    </div>
  </div>`;

  return wrapPreviewHtml(body, orientation, WEATHER_CSS, `background:${bg}`);
}

function estimateGameCount(selections) {
  if (!Array.isArray(selections) || !selections.length) return 4;
  let count = 0;
  for (const sel of selections) {
    if (sel.type === 'games') count += sel.eventIds?.length || 1;
    else if (sel.type === 'top') count += sel.limit || 4;
    else if (sel.type === 'sport') count += 4;
    else count += 1;
  }
  return Math.min(Math.max(count, 1), 9);
}

function pickLayout(count) {
  if (count === 1) return 'solo';
  if (count === 2) return 'duo';
  if (count <= 4) return 'quad';
  if (count <= 6) return 'six';
  return 'many';
}

const TEAM_PAIRS = [['LAL', 'BOS'], ['NYK', 'MIA'], ['DAL', 'PHX'], ['CHI', 'GSW']];
const STATUS_CYCLE = [
  { status: 'in', statusLabel: 'Q3 · 4:32', away: '88', home: '91' },
  { status: 'pre', statusLabel: '7:30 PM', away: '–', home: '–' },
  { status: 'post', statusLabel: 'Final', away: '102', home: '98' },
];

function renderStatusBadge(game) {
  if (game.status === 'in') {
    return '<div class="status-badge status-live"><span class="live-dot"></span><span class="status-text">LIVE</span></div>';
  }
  if (game.status === 'post') {
    return '<div class="status-badge status-final"><span class="status-text">FINAL</span></div>';
  }
  return `<div class="status-badge status-upcoming"><span class="status-text">UPCOMING · ${escapeHtml(game.statusLabel)}</span></div>`;
}

function renderGameCard(game, layout) {
  if (layout === 'solo') {
    const show = game.status !== 'pre';
    return `
    <div class="game-card solo">
      ${renderStatusBadge(game)}
      <div class="solo-center">
        <div class="solo-side"><span class="skeleton-logo solo-logo"></span><span class="solo-abbr">${escapeHtml(game.away)}</span></div>
        <div class="solo-scores">
          <span class="solo-score">${show ? game.awayScore : '–'}</span>
          <span class="solo-divider">–</span>
          <span class="solo-score">${show ? game.homeScore : '–'}</span>
        </div>
        <div class="solo-side"><span class="skeleton-logo solo-logo"></span><span class="solo-abbr">${escapeHtml(game.home)}</span></div>
      </div>
      ${game.status === 'in' ? `<div class="solo-clock">${escapeHtml(game.statusLabel)}</div>` : ''}
      <div class="solo-league">${escapeHtml(game.league)}</div>
    </div>`;
  }
  const show = game.status !== 'pre';
  return `
  <div class="game-card ${layout}">
    ${renderStatusBadge(game)}
    <div class="card-body">
      ${game.status === 'in' ? `<div class="game-clock">${escapeHtml(game.statusLabel)}</div>` : ''}
      <div class="teams">
        <div class="team-row"><span class="skeleton-logo team-logo"></span><span class="team-abbr">${escapeHtml(game.away)}</span>${show ? `<span class="team-score">${escapeHtml(game.awayScore)}</span>` : ''}</div>
        <div class="team-row"><span class="skeleton-logo team-logo"></span><span class="team-abbr">${escapeHtml(game.home)}</span>${show ? `<span class="team-score">${escapeHtml(game.homeScore)}</span>` : ''}</div>
      </div>
    </div>
    <div class="league-tag">${escapeHtml(game.league)}</div>
  </div>`;
}

function buildSportsPreviewHtml(config = {}, options = {}) {
  const orientation = options.orientation === 'portrait' ? 'portrait' : 'landscape';
  const selections = Array.isArray(config.selections) ? config.selections : [];
  const count = estimateGameCount(selections);
  const layout = pickLayout(count);
  const league = selections[0]?.sportKey?.toUpperCase() || 'NBA';

  const games = Array.from({ length: count }, (_, i) => {
    const c = STATUS_CYCLE[i % STATUS_CYCLE.length];
    const [away, home] = TEAM_PAIRS[i % TEAM_PAIRS.length];
    return {
      away,
      home,
      awayScore: c.away,
      homeScore: c.home,
      status: c.status,
      statusLabel: c.statusLabel,
      league,
    };
  });

  const cardsHtml = games.map((g) => renderGameCard(g, layout)).join('');
  const title = selections.length ? 'Your scoreboard' : 'Sample scoreboard';

  const body = `
  <div class="scene ${count === 1 ? 'scene-solo' : ''}">
    <div class="header ${count === 1 ? 'header-compact' : ''} anim-fade">
      <h1 class="title">Live Scores</h1>
      ${count === 1 ? '' : `<p class="subtitle">${escapeHtml(title)}</p>`}
    </div>
    <div class="scoreboard anim-slide ${layout}-grid">${cardsHtml}</div>
  </div>`;

  return wrapPreviewHtml(body, orientation, SPORTS_CSS, null);
}

const TRIVIA_CSS = `* { box-sizing: border-box; margin: 0; padding: 0; }
html, body { width: 100%; height: 100%; overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; color: #fff; }
html.landscape .scene { width: 1920px; height: 1080px; }
html.portrait .scene { width: 1080px; height: 1920px; }
body {
  background:
    radial-gradient(ellipse at 20% 15%, rgba(255, 90, 180, 0.22), transparent 45%),
    radial-gradient(ellipse at 85% 20%, rgba(90, 120, 255, 0.28), transparent 40%),
    linear-gradient(160deg, #0c1020 0%, #151a32 45%, #1a1430 100%);
}
.scene { position: relative; width: 100%; height: 100%; overflow: hidden; }
.title-stage {
  position: absolute; left: 50%; top: 48px; transform: translate(-50%, 0) scale(0.34);
  transform-origin: center top;
  z-index: 5; display: flex; align-items: center; justify-content: center;
}
.title-fx { position: absolute; left: 50%; top: 50%; width: 0; height: 0; }
.spiral {
  position: absolute; left: 0; top: 0; width: 420px; height: 420px; margin: -210px 0 0 -210px;
  border-radius: 50%; border: 3px solid transparent; opacity: 0.55;
  animation: triviaSpin 4s linear infinite;
}
.spiral-a { border-top-color: rgba(143,212,0,.9); border-right-color: rgba(47,123,255,.5); }
.spiral-b {
  width: 320px; height: 320px; margin: -160px 0 0 -160px;
  border-bottom-color: rgba(255,47,155,.9); border-left-color: rgba(255,122,26,.5);
  animation-direction: reverse; animation-duration: 3.2s;
}
.spiral-c {
  width: 240px; height: 240px; margin: -120px 0 0 -120px;
  border-top-color: rgba(31,201,176,.9); border-left-color: rgba(123,63,242,.5);
  animation-duration: 2.4s;
}
@keyframes triviaSpin { to { transform: rotate(360deg); } }
.spark {
  position: absolute; left: 0; top: 0; width: 8px; height: 8px; margin: -4px 0 0 -4px;
  border-radius: 50%; background: #fff; opacity: 0.85;
  box-shadow: 0 0 10px currentColor;
  animation: triviaSpark 2.2s ease-in-out infinite;
}
.spark:nth-child(3n) { color: #8fd400; animation-delay: .1s; }
.spark:nth-child(3n+1) { color: #ff2f9b; animation-delay: .35s; }
.spark:nth-child(3n+2) { color: #2f7bff; animation-delay: .2s; }
@keyframes triviaSpark {
  0%, 100% { transform: translate(0,0) scale(.6); opacity: .3; }
  50% { transform: translate(var(--sx), var(--sy)) scale(1.2); opacity: 1; }
}
.title-word { position: relative; z-index: 2; display: flex; gap: 14px; }
.tile {
  width: 120px; height: 120px; border-radius: 18px; display: flex; align-items: center;
  justify-content: center; font-size: 68px; font-weight: 800; color: #fff;
  border: 4px solid #fff; box-shadow: 0 10px 0 rgba(196,160,90,.95), 0 18px 28px rgba(0,0,0,.35);
}
.tile:nth-child(1) { background: linear-gradient(145deg,#a8e623,#8fd400); transform: rotate(-5deg); }
.tile:nth-child(2) { background: linear-gradient(145deg,#9a5cff,#7b3ff2); transform: rotate(4deg); }
.tile:nth-child(3) { background: linear-gradient(145deg,#5a9bff,#2f7bff); transform: rotate(-3deg); }
.tile:nth-child(4) { background: linear-gradient(145deg,#ff5ab3,#ff2f9b); transform: rotate(5deg); }
.tile:nth-child(5) { background: linear-gradient(145deg,#ff9a45,#ff7a1a); transform: rotate(-4deg); }
.tile:nth-child(6) { background: linear-gradient(145deg,#3fe0c8,#1fc9b0); transform: rotate(3deg); }
.content {
  position: absolute; inset: 0; display: flex; flex-direction: column;
  align-items: center; justify-content: center; padding: 180px 96px 80px; text-align: center;
}
.category { font-size: 24px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase;
  color: rgba(255,255,255,0.72); margin-bottom: 24px; }
.question { font-size: 52px; font-weight: 700; line-height: 1.2; max-width: 1400px; }
.answer-panel {
  margin-top: 40px; padding: 24px 40px; border-radius: 24px;
  background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.22);
}
.answer-label { font-size: 18px; letter-spacing: 0.16em; text-transform: uppercase; color: #ffd56a; margin-bottom: 8px; }
.answer { font-size: 44px; font-weight: 800; }`;

function buildTriviaPreviewHtml(_config = {}, options = {}) {
  const orientation = options.orientation === 'portrait' ? 'portrait' : 'landscape';
  const sparks = Array.from({ length: 12 }, (_, i) => {
    const angle = (i / 12) * Math.PI * 2;
    const r = 140 + (i % 3) * 24;
    const sx = Math.round(Math.cos(angle) * r);
    const sy = Math.round(Math.sin(angle) * r * 0.7);
    return `<span class="spark" style="--sx:${sx}px;--sy:${sy}px"></span>`;
  }).join('');
  const body = `
  <div class="scene">
    <div class="title-stage">
      <div class="title-fx" aria-hidden="true">
        <div class="spiral spiral-a"></div>
        <div class="spiral spiral-b"></div>
        <div class="spiral spiral-c"></div>
        ${sparks}
      </div>
      <div class="title-word" aria-label="TRIVIA">
        <span class="tile">T</span><span class="tile">R</span><span class="tile">I</span>
        <span class="tile">V</span><span class="tile">I</span><span class="tile">A</span>
      </div>
    </div>
    <div class="content">
      <div class="category">General Knowledge</div>
      <div class="question">Which planet is known as the Red Planet?</div>
      <div class="answer-panel">
        <div class="answer-label">Answer</div>
        <div class="answer">Mars</div>
      </div>
    </div>
  </div>`;
  return wrapPreviewHtml(body, orientation, TRIVIA_CSS, null);
}

export {
  buildWeatherPreviewHtml,
  buildSportsPreviewHtml,
  buildTriviaPreviewHtml,
};
